<template>
  <div tabindex="0" ref="wrapper" class="popup__wrapper" data-scroll-lock-scrollable @keydown="keymonitor" :style="{'display': show ? '' : 'none'}">
    <div class="popup" :style="{'display': show? '' : 'none'}">
      <div class="popup__close" v-if="closeable" @click.prevent="close">close</div>
      <div class="popup__body">
        <slot />
      </div>
    </div>
  </div>
</template>
<script setup>
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { ref, onMounted, watch, nextTick } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: () => false,
    },
    browserCompatMode: {
        type: Boolean,
        default: () => false,
    },
    inner: {
        type: Boolean,
        default: false
    },
    closeable: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:show'], ['modal:close']);

const close = () => {
    emit('update:show', false);
};

const keymonitor = (event) => {
    if (event.key == 'Escape') {
        close();
    }
}


const scrollbarWidth = ref(0);
const scrollPosition = ref(0);


const safariFormHack = () => {
    if (val) {
        scrollPosition.value = window.pageYOffset;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition.value}px`;
        document.body.style.width = '100%';
    } else {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition.value);
    }

};

const wrapper = ref(null);

watch(() => props.show, (val)=> {
    if (!props.inner) {
        if (val) {
            document.body.classList.add("height");
            document.body.style.paddingRight = scrollbarWidth.value + 'px';
            disablePageScroll();
        } else {
            document.body.classList.remove("height");
            document.body.style.paddingRight = 0;
            enablePageScroll();
        }
        if (props.browserCompatMode) {
            safariFormHack(val);
        }
    }

    nextTick(() => {
        wrapper.value.focus();
    });

});


onMounted(() => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    scrollbarWidth.value = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    if (props.show && !props.inner) {
        disablePageScroll();
    }
});

</script>
